export default __webpack_public_path__ + "static/feed_bg_text-283ee4a8ea24906746f2d54d74d81211.png";